module.exports = __webpack_public_path__ + "img/rugbyLes4.3c6c19d0.jpg";